/* eslint-disable no-console */

export const isEmpty = obj => (!obj || (!obj.length && !Object.keys(obj).length));
export const stringify = (value) => {
  /* eslint-disable no-extend-native */
  let stringified;
  let toJSONPrototype;
  if (typeof Array.prototype.toJSON === 'function') {
    toJSONPrototype = Array.prototype.toJSON;
    delete Array.prototype.toJSON;
    try {
      stringified = JSON.stringify(value);
    } catch (e) {
      Array.prototype.toJSON = toJSONPrototype;
      throw e;
    }
    Array.prototype.toJSON = toJSONPrototype;
  } else {
    stringified = JSON.stringify(value);
  }
  return stringified;
};

export const clone = (obj) => {
  let retVal;
  try {
    retVal = JSON.parse(stringify(obj));
  } catch (e) {
    console.log(`unable to clone object: ${JSON.stringify(e)}`);
  }
  return retVal;
};

export const extend = (obj, extendObj, deep) => {
  let newObj = {};

  if (!obj || typeof obj !== 'object') {
    return obj;
  }

  if (!extendObj) {
    return clone(obj);
  }

  newObj = extendObj;
  Object.keys(obj).forEach((prop) => {
    if (Object.prototype.hasOwnProperty.call(obj, prop)) {
      newObj[prop] = deep ? extend(obj[prop], undefined, deep) : obj[prop];
    }
  });

  return newObj;
};



// WEBPACK FOOTER //
// ./src/logger/utils.js